import React from 'react';
import {
  RESTORE_ACCEPTED_CONFIRM,
  RESTORE_ACCEPTED_KEEP,
  RESTORE_ACCEPTED_PUT_BACK,
} from '../../utils/writerCopy';
import ShrinkGuardDialog from './ShrinkGuardDialog';

/**
 * Ask before a hand-edited scene is replaced with the accepted version.
 * Keep my edits is the default. Put back is the only action that reverts.
 */
export default function RestoreAcceptedDialog({ onPutBack, onKeepEdits }) {
  return (
    <ShrinkGuardDialog
      title={RESTORE_ACCEPTED_CONFIRM}
      keepLabel={RESTORE_ACCEPTED_KEEP}
      confirmLabel={RESTORE_ACCEPTED_PUT_BACK}
      titleId="sw-restore-accepted-title"
      onSave={onPutBack}
      onKeepEditing={onKeepEdits}
    />
  );
}
